import { render } from "./ItensNFCreate.vue?vue&type=template&id=525b2f56&scoped=true"
import script from "./ItensNFCreate.vue?vue&type=script&lang=js"
export * from "./ItensNFCreate.vue?vue&type=script&lang=js"

import "./ItensNFCreate.vue?vue&type=style&index=0&id=525b2f56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525b2f56"]])

export default __exports__